import { Icon } from 'assets/icons';
import React from 'react';
import { NavLink, useMatch } from 'react-router-dom';
import styles from './item.module.css';

const SideNavItem = ({ title, name, path, match, onClick, onItemClick }) => {
  const is_match = useMatch({ path: match || path, end: !match });

  const handleItemClick = () => {
    if (onClick) onClick();
    onItemClick();
  };

  const active_class = is_match ? ` ${styles.active}` : '';

  return (
    <>
      {!path ? (
        <div className={styles.item} onClick={handleItemClick}>
          <div>
            <span className={styles.icon}>
              <Icon name={name} height={16} width={16} />
            </span>
            <div className={styles.title}>{title}</div>
          </div>
        </div>
      ) : (
        <NavLink
          to={path}
          className={() => `${styles.item}${active_class}`}
          onClick={handleItemClick}
        >
          <div>
            <span className={styles.icon}>
              <Icon name={name} height={16} width={16} />
            </span>
            <div className={styles.title}>{title}</div>
          </div>
        </NavLink>
      )}
    </>
  );
};

export default SideNavItem;
